import { render, staticRenderFns } from "./MarketingForm.vue?vue&type=template&id=1cfbec42&scoped=true&"
import script from "./MarketingForm.vue?vue&type=script&lang=ts&"
export * from "./MarketingForm.vue?vue&type=script&lang=ts&"
import style0 from "./MarketingForm.vue?vue&type=style&index=0&id=1cfbec42&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.10.1_cache-loader@4.1.0_css-loader@3.6.0_vue-template-compiler@2.7.14_webpack@4.46.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cfbec42",
  null
  
)

export default component.exports